export default "__VITE_ASSET__10c1f226__"